import { SagaIterator } from 'redux-saga';
import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';

import { Common } from '../actions';
import { CommonActionTypes } from '../actions/common/action-types';
import { CommonsApi } from '../api/common';


function* getLocations(): SagaIterator {
  try {
    const data = yield call(CommonsApi.getLocations);
    yield put(Common.getLocationsSuccessed(data));
  } catch (e) {
    console.error(e);
  }
}

export function* commonSagas(): IterableIterator<ForkEffect> {
  yield takeLatest(CommonActionTypes.GET_LOCATIONS, getLocations);
}
